import { render, staticRenderFns } from "./EmailMessage.vue?vue&type=template&id=6aec7884&scoped=true&"
import script from "./EmailMessage.vue?vue&type=script&lang=js&"
export * from "./EmailMessage.vue?vue&type=script&lang=js&"
import style0 from "./EmailMessage.vue?vue&type=style&index=0&id=6aec7884&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aec7884",
  null
  
)

export default component.exports